export default "__VITE_ASSET__qwoIAXhA__"